import styled from "styled-components";
import { Select } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const StyledSelect = styled(Select)`
    && {
        color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    }
`;
